import { getAxiosBackendMubinApi } from "../helpers/axios"

class MubinApiServices{
    
    constructor(){
    }

    checkcode(data){
        return getAxiosBackendMubinApi().get(data)
    }
}

export default new MubinApiServices()